// This file is auto-generated by @hey-api/openapi-ts

export const RelationalTariffProfileTypesEnum = { COUPON: 'COUPON', SINGLE: 'SINGLE' } as const;

export type RelationalTariffProfileTypesEnum = typeof RelationalTariffProfileTypesEnum[keyof typeof RelationalTariffProfileTypesEnum];
